<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="12">
          <v-text-field
            :label="'Description'"
            v-model="transport.name"
          ></v-text-field>
        </v-col>

        <v-col :cols="12"
          ><v-text-field
            :label="'Fee/Km or Mile'"
            type="number"
            v-model="transport.price"
          ></v-text-field
        ></v-col>

        <v-col :cols="12">
          <v-text-field
            :label="'Kilometers / Miles'"
            v-model="transport.quantity"
          ></v-text-field>
        </v-col>

        <v-col :cols="6"
          ><v-btn @click="regeneratePDF()" color="teal" dark
            ><v-icon>mdi-check</v-icon>Add Transport</v-btn
          ></v-col
        >
      </v-row>
    </v-container>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
export default {
  data: () => ({
    transport: {
      name: null,
      cost: 0,
      price: 0,
      code: "SX-192-01",
      category_id: 0,
      list_on_store: "No",
      item_type: "transportation",
      quantity: 1,
      category: {
        id: 0,
        name: "Transportation",
      },
      imagePath: "/images/products/no-photo.jpg",
      link: "12121111211",
    },
  }),

  methods: {
    regeneratePDF() {
      if (!this.transport.name) {
        alert("Description is Required!");
        return false;
      }
      this.transport.price = this.stripNonDigitsAndCommasFromMoney(
        this.transport.price
      );
      this.$emit("transport-updated", this.transport);
    },
    stripNonDigitsAndCommasFromMoney(amount) {
      return helpersJs.stripNonDigitsAndCommasFromMoney(amount);
    },
  },
};
</script>

<style></style>
